import { $k18n } from '@/common/i18n';
import { styles, padding } from '@/common/style';
import { KImage, KText, KView } from '@/component/RtlLayout';
import { useCheckoutDetailPopup } from '../ShopCard/hooks/useCheckoutDetailPopup';
import React, { FC, Ref, useEffect, useMemo, useState } from 'react';
import Popup from '@kibt/meta-ui-krn/lib/components/Popup';
import { ImageStyle, TouchableOpacity, TouchableWithoutFeedback, Text, View } from 'react-native';
import Image from '@kds/image';
import MerchantBagIcon from '@/assets/icon/merchant_bag_icon.png';
import { Progress, Toast } from '@kibt/meta-ui-krn';
import Flex from '@/component/atom/Flex';
import CompaleteIcon from '@/assets/icon/complete.png';
import { vIf } from '@/common/utils/vIf';
import Button from '@/component/Button/Button';
import IconArrowRed from '@/assets/icon/icon_arrow_right_red.png';
import ShopCard from '../ShopCard';
import { useDelSelectProductItem, useGetStoreCartItem, useQuery, useSelectProducts, useSetCartItemNum } from '../hooks/useGetStoreCartItem';
import { getIsBra } from '@/common/const';
import { useShopInfoStore } from '../store/shopInfoStore';
import { isIOS } from '@kibt/krn-utils';
import { isWeb, screenHeight } from '@/common/device-info';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useJumpToConfirmOrder } from '@/common/biz/jump';
import { sendClickAddonItem } from '@/page/recommendGoods/logger';
import { claimSelfMultiBuildCoupon } from '@/page/detail/views/api';
import { useIosFixedNativeID } from '@/hooks/useFixedPosition';
import { useExtraInfoObject } from '@/page/merchant/views/components/BottomNode';

interface IProp {
    storeCartItem: any;
    CartIconAnimation: FC;
    cartIconRef: Ref<React.ReactElement | null>;
    pageStatus?: string; // 半屏 / 全屏
    pageHeight?: number;
    targetMakeupCoupon?: any; // 目标凑单券
}

export const BottomCheck: FC<IProp> = (props: IProp) => {
    const { storeCartItem = {}, CartIconAnimation, cartIconRef, targetMakeupCoupon, pageStatus } = props;
    const { query } = useQuery();
    const selectedCartItemList = useMemo(() => {
        return storeCartItem?.cartShopList[0]?.cartItemList.filter((item) => item.isSelected);
    }, [storeCartItem, storeCartItem?.cartShopList[0]?.cartItemList]);
    const {
        popupNode: checkoutDetailPopup,
        visible: checkoutDetailPopupVisible,
        setVisible: setCheckoutDetailPopupVisible,
    } = useCheckoutDetailPopup({ shopCartItem: storeCartItem?.cartShopList?.[0] });
    const inset = useSafeAreaInsets();
    const insetBottom = isIOS ? inset.bottom : 0;

    const bottomNodeHeight = 72 + insetBottom;

    const percentage = useMemo(() => {
        // 没选中
        const isNoSelected = selectedCartItemList?.length === 0;

        const targetCoupon =
            targetMakeupCoupon.discountFeeType === 3
                ? storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.shippingMakeupCoupons
                : storeCartItem?.cartShopList[0]?.shopEvaluate?.shopEvaluateCoupon?.itemMakeupCoupons;

        // 商品凑单券
        const { currentLevel: currentLevelCoupon, nextLevel: nextLevelCoupon, amountToNextLevel } = targetCoupon || {};
        // 没有券
        const noCoupon = !currentLevelCoupon && !nextLevelCoupon;
        const nextLevelCouponThreshold = nextLevelCoupon?.threshold?.amount ?? Infinity;

        if (isNoSelected || noCoupon) {
            return 0;
        }

        // 有凑够的就显示100 @zhangyi
        // 没有更高的了，凑完了也显示100
        if (currentLevelCoupon || nextLevelCoupon === Infinity) {
            return 100;
        }

        const percent = Math.floor(((nextLevelCouponThreshold - amountToNextLevel.amount) / nextLevelCouponThreshold) * 100);
        return percent;
    }, [selectedCartItemList, storeCartItem, targetMakeupCoupon]);

    const [visiblePopCart, setVisiblePopCart] = useState(false);

    const onHandleClosePopCart = () => {
        setVisiblePopCart(false);
    };

    const openCart = () => {
        if (checkoutDetailPopupVisible) return setCheckoutDetailPopupVisible(false);
        setVisiblePopCart(!visiblePopCart);
    };

    const onOpenCheckoutDetail = () => {
        if (visiblePopCart) return setVisiblePopCart(false);
        setCheckoutDetailPopupVisible(!checkoutDetailPopupVisible);
    };
    const ProgressComNode = (_percentage) => {
        if (_percentage === 100) {
            return (
                <KView>
                    <KImage style={{ width: 12, height: 12 }} source={CompaleteIcon} />
                </KView>
            );
        }
        return null;
    };
    const setStoreCartItem = useShopInfoStore((state) => state.setStoreCartItem);
    const shopDiscount = storeCartItem?.cartShopList?.[0]?.shopEvaluate?.shopDiscount;
    const { selectProductItem } = useSelectProducts();
    const { setCartItemNum } = useSetCartItemNum();
    const { deleteProductItem } = useDelSelectProductItem();
    const { loadShopData: loadSelectHaltScreen } = useGetStoreCartItem();
    const refreshCart = () => {
        loadSelectHaltScreen();
    };

    const [cartHeight, setCartHeight] = useState(0);
    const [claiming, setClaiming] = useState(false);
    const extraInfoObj = useExtraInfoObject();

    const onThrottledOpenCart = () => {
        openCart();
        setTimeout(() => {
            refreshCart();
        });
    };

    const { jumpToConfirmOrder } = useJumpToConfirmOrder();
    async function handleCheckout() {
        if (selectedCartItemList.length === 0) {
            Toast.show({ text: $k18n({ id: 'k_385882', text: '请选中要结算的商品' }) });
            return;
        }
        if (selectedCartItemList.length > storeCartItem.selectedLimit) {
            Toast.show({ text: $k18n({ text: '最多选择{num}个商品，请分开结算', params: { num: storeCartItem.selectedLimit } }) });
            return;
        }

        if (claiming) return;

        if (storeCartItem?.selectedInsufficient) {
            Toast.show({
                text: $k18n({
                    id: 'k_370316',
                    text: '部分商品信息有变更',
                }),
            });
            return;
        }
        const isFromCart = extraInfoObj.entrance_type && extraInfoObj.entrance_type.indexOf('rn_my_shopping_car') > -1;

        sendClickAddonItem({
            itemId: selectedCartItemList?.map((v) => v.itemId).join(','),
            skuId: selectedCartItemList?.map((v) => v.skuId).join(','),
            batchId: targetMakeupCoupon?.batchId,
            clickArea: 'buy',
        });

        function jump() {
            jumpToConfirmOrder({
                fromMyShoppingCar: 1,
                productItems: selectedCartItemList.map((v) => ({
                    cartItemId: v.cartItemId,
                    merchantId: storeCartItem.cartShopList[0].merchantId,
                    skuId: v.skuId,
                    num: v.skuQuantity,
                    itemId: v.itemId,
                    sellerMerchantId: null,
                    flashSaleActivityId: v?.flashSaleInfo?.activityId,
                })),
            });
        }
        // 优惠券自动领取
        const shippingCouponIds = storeCartItem.cartShopList[0].shopEvaluate?.shopEvaluateCoupon?.claimableBatchIdList;
        console.log('jump::to order confirm::', storeCartItem.cartShopList[0].shopEvaluate);
        if (shippingCouponIds?.length) {
            console.log('jump::有券，要领了', shippingCouponIds);
            setClaiming(true);
            await claimSelfMultiBuildCoupon({ batchIds: shippingCouponIds?.join(',') }).finally(() => setClaiming(false));
            console.log('jump::领取成功::等待1.5s', storeCartItem.cartShopList[0].shopEvaluate);
            Toast.show({
                duration: 1000,
                text: $k18n({ text: '已成功帮您领取优惠券，快来下单', id: 'k_445554' }),
            });
            setTimeout(() => {
                console.log('1.5s了', storeCartItem.cartShopList[0].shopEvaluate);
                jump();
            }, 1500);
        } else {
            console.log('jump::没券', shippingCouponIds);
            jump();
        }
    }

    const bottomNode = () => {
        return (
            <KView
                style={{
                    paddingRight: 19,
                    paddingLeft: 19,
                    paddingTop: 16,
                    paddingBottom: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    borderTopWidth: 1,
                    borderTopColor: 'rgba(0, 0, 0, 0.10)',
                    height: 72,
                }}
            >
                <KView style={{ marginRight: 16 }}>
                    <KView>
                        <TouchableWithoutFeedback onPress={() => onThrottledOpenCart()}>
                            <KView>
                                <CartIconAnimation>
                                    <KView collapsable={false} ref={cartIconRef}>
                                        <KImage style={{ width: 40, height: 40 }} source={MerchantBagIcon} />
                                        {selectedCartItemList?.length > 0 ? (
                                            <KView
                                                style={styles({
                                                    top: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    transform: [{ translateX: 8 }],
                                                })}
                                            >
                                                <KView
                                                    style={styles({
                                                        backgroundColor: '#f00',
                                                        ...padding(2, 4),
                                                        borderRadius: 20,
                                                        top: 0,
                                                        right: 0,
                                                        overflow: 'hidden',
                                                        ...(Number(selectedCartItemList?.length) < 10 ? { borderRadius: 7.5 } : {}),
                                                    })}
                                                >
                                                    <KText
                                                        style={styles({
                                                            fontWeight: '700',
                                                            fontSize: 8,
                                                            lineHeight: 9,
                                                            color: '#fff',
                                                        })}
                                                    >
                                                        {selectedCartItemList?.length > 99 ? '99+' : selectedCartItemList?.length}
                                                    </KText>
                                                </KView>
                                            </KView>
                                        ) : null}
                                    </KView>
                                </CartIconAnimation>
                            </KView>
                        </TouchableWithoutFeedback>
                    </KView>
                </KView>

                <KView style={{ flex: 1 }}>
                    <KView>
                        <KView style={{ width: '100%', marginTop: percentage !== 100 ? 4 : 0, marginBottom: percentage !== 100 ? 4 : 0 }}>
                            <Progress key={percentage} percentage={percentage} pivotNode={ProgressComNode(percentage)} />
                        </KView>
                        {selectedCartItemList?.length ? (
                            <KView style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Text
                                    style={styles({
                                        fontSize: shopDiscount?.itemCouponDiscount?.now?.displayAmount?.length > 10 ? 12 : 16,
                                        fontWeight: '700',
                                        color: '#000',
                                        marginRight: 8,
                                        marginTop: 2,
                                    })}
                                >
                                    {shopDiscount?.itemCouponDiscount?.now?.displayAmount}
                                </Text>
                                {vIf(
                                    [!!shopDiscount?.itemTotalDiscount?.amount],
                                    <TouchableOpacity activeOpacity={0.6} onPress={() => onOpenCheckoutDetail()}>
                                        <Flex flex={'flexRowCenter'} style={{ marginTop: 4 }}>
                                            <Text style={[styles({ fontSize: 12 }), { color: 'rgba(255, 73, 6, 1)' }]}>
                                                {$k18n({
                                                    id: 'k_322805',
                                                    text: '{discount} OFF',
                                                    params: { discount: shopDiscount?.itemTotalDiscount?.displayAmount },
                                                })}
                                            </Text>
                                            <Image
                                                style={
                                                    styles({
                                                        width: 16,
                                                        height: 16,
                                                        transform: [{ rotate: checkoutDetailPopupVisible ? '-90deg' : '90deg' }],
                                                    }) as ImageStyle
                                                }
                                                source={IconArrowRed}
                                            />
                                        </Flex>
                                    </TouchableOpacity>,
                                )}
                            </KView>
                        ) : (
                            <Text
                                style={styles({
                                    fontSize: shopDiscount?.itemCouponDiscount?.now?.displayAmount?.length > 10 ? 12 : 16,
                                    fontWeight: '700',
                                    color: '#000',
                                    marginRight: 8,
                                    marginTop: 2,
                                })}
                            >
                                {getIsBra() ? 'R$0,00' : 'Rp0,00'}
                            </Text>
                        )}
                        {/* todo 分两行展示情况 */}
                    </KView>
                </KView>

                <KView style={{ marginLeft: 16 }}>
                    <Button size="small" type="primary" allowPress={true} onPress={handleCheckout}>
                        {$k18n('结算')}
                    </Button>
                </KView>
            </KView>
        );
    };

    useEffect(() => {
        setVisiblePopCart(false);
    }, [props.pageStatus]);

    const bottom = bottomNodeHeight + (isIOS ? screenHeight - (props.pageHeight || screenHeight) : 0);
    const popHeight = props.height - bottom;
    const shopCartHeight = popHeight;

    const fixedState = useIosFixedNativeID();

    return (
        <>
            <KView
                style={styles({
                    height: bottomNodeHeight,
                    zIndex: 110,
                    backgroundColor: '#fff',
                    paddingBottom: isIOS && !isWeb ? insetBottom : 0,
                })}
            >
                {bottomNode()}
            </KView>

            {/* 加购物车的商品弹框 */}
            <Popup
                boxStyle={{ bottom }}
                lockScroll={true}
                maskZindex={101}
                visible={visiblePopCart}
                duration={150}
                onClose={() => onHandleClosePopCart()}
                position="bottom"
            >
                <View
                    style={{
                        backgroundColor: '#fff',
                        height: popHeight,
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        paddingTop: 6,
                        overflow: 'hidden',
                    }}
                    nativeID={fixedState.nativeID}
                    onLayout={({ nativeEvent }) => {
                        if (cartHeight === 0) {
                            console.log('nativeEvent.layout.height', nativeEvent.layout.height);
                            setCartHeight(nativeEvent.layout.height);
                        }
                    }}
                >
                    <ShopCard
                        handleCheck={selectProductItem}
                        handleDelete={(ids) =>
                            storeCartItem.cartShopList?.[0]?.merchantId && deleteProductItem(ids, storeCartItem.cartShopList[0].merchantId)
                        }
                        height={shopCartHeight}
                        handleSetCartItemNum={(cartItemId, num, selected = true) =>
                            setCartItemNum(cartItemId, num, storeCartItem?.cartShopList?.[0].merchantId, selected)
                        }
                        shopCartItem={storeCartItem?.cartShopList?.[0]}
                        onClose={onHandleClosePopCart}
                    />
                </View>
            </Popup>

            {/* 优惠价格明细弹框 */}
            {checkoutDetailPopup(bottom, shopCartHeight)}
        </>
    );
};
